import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { LexTranslateService } from '@app/core/services/lex-translate.service';
import { DEFAULT_PAGE_SIZE } from 'src/app/cadastro/admin/lib/constants';
import { Helpers } from '../../../helpers';

@Component({
  selector: 'seb-table-paggination',
  templateUrl: './table-paggination.component.html',
  styleUrls: ['./table-paggination.component.css']
})
export class TablePagginationComponent implements OnInit {

  @Input() nTamanhoPagination: number;
  @Input() nDefault = 1;
  @Input() nItensPerPage = DEFAULT_PAGE_SIZE;
  @Input() notScrollTop: boolean = false;
  @Output() evIndexPag = new EventEmitter;

  showNextPage = true;
  showPreviousPage = false;
  constrolPag: Array<any>;

  constructor(public lextranslate: LexTranslateService) {}

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    if (this.nDefault == null || this.nDefault === undefined) {
      this.nDefault = 1;
    }
    if (this.nItensPerPage == null || this.nItensPerPage === undefined) {
      this.nItensPerPage = DEFAULT_PAGE_SIZE;
    }

    this.bildNextPrevPagination(this.nDefault);
  }

  onclick(index: number) {
    if (index) {
      this.nDefault = index;
      this.evIndexPag.emit(this.nDefault);
    }
    this.bildNextPrevPagination(this.nDefault);
    if(!this.notScrollTop){
      Helpers.goToTopOfPage();
    }
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }

  renderAtual(value: any) {
    return value === this.nDefault;
  }

  onPrev() {
    if (this.nDefault !== 1) {
      this.nDefault -= 1;
      this.evIndexPag.emit(this.nDefault);
    }
    this.bildNextPrevPagination(this.nDefault);
    Helpers.goToTopOfPage();
  }

  onNext() {
    if (this.nDefault !== Math.ceil(this.nTamanhoPagination / this.nItensPerPage)) {
      this.nDefault += 1;
      this.evIndexPag.emit(this.nDefault);
    }
    this.bildNextPrevPagination(this.nDefault);
    Helpers.goToTopOfPage();
  }

  typeItem(value: any) {
    return typeof value;
  }

  bildNextPrevPagination(currentPage: number) {
    this.showPreviousPage = this.nDefault == 1 ? false : true;
    this.showNextPage = this.nDefault !== Math.ceil(this.nTamanhoPagination / this.nItensPerPage) ? true : false;
  }
}
